// src/features/tickets/services/tickets.queryKeys.ts
export const TICKET_KEYS = {
    base: 'tickets',
    all: ['tickets'],
    list: (filters?: Record<string, unknown>) =>
        filters ? ['tickets', 'list', filters] : ['tickets', 'list'],
    detail: (id: string) => ['tickets', 'detail', id]
} as const;
